import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import { Text, Flex } from 'react-orange-ui';

import Spinner from '../../Spinner/Spinner';
import ContactList from './ContactList';
import UseTemporaryPassword from "./UseTemporaryPassword";
import GetLetter from './GetLetter';
import NoContact from '../../../containers/NoContact';

import TagService from '../../../services/TagService';
import WordingService from '../../../services/WordingService';
import Space from '../../../orange-ui/components/Spaces/Space';
import { MOBILE_TYPE, EMAIL_TYPE, MULTIBAL_ACCOUNT } from '../../../helpers/account';
import MultibalCannotUseContact from './MultibalCannotUseContact';

const getTitle = (contacts) => {
  if (contacts.length === 1) {
    const contact = contacts[0];
    switch (contact.contactType) {
      case MOBILE_TYPE:
        return WordingService.getWording('caption', 'noMobileAccess');
      case EMAIL_TYPE:
        return WordingService.getWording('caption', 'noEmailAccess');
      default:
    }
  } else if (contacts.length >= 2) {
    return WordingService.getWording('caption', 'noContactAccess');
  } else {
    return WordingService.getWording('caption', 'accessService');
  }
};

export class ChoiceView extends Component {
  componentDidMount() {
    const { getIdentitiesAndContacts } = this.props;

    getIdentitiesAndContacts();
  }

  /**
   * Handler click
   * Send reports to GA
   * Set selected contact
   * Send OTC with selected contact
   */
  handleClick = (contact) => {
    const { sendOtp, setSelectedContact, isFetching } = this.props;

    if (!isFetching) {
      switch (contact.contactType) {
        case MOBILE_TYPE:
          TagService.sendAction('resetBySms');
          break;
        case EMAIL_TYPE:
          TagService.sendAction('resetByMail');
          break;
        default:
          break;
      }
      setSelectedContact(contact);
      sendOtp({ contact });
    }
  };

  /**
   * Display the contacts when is fetched, else show a spinner.
   * Display temporary password options when possible
   * @return {*}
   */
  render() {
    const { identities, contacts, isFetching, webViewMode } = this.props;

    const accountLevel = identities.accountLevel;
    const letterOrder = identities.isFirstConnection === '1' ? '2' : '0';

    if (isFetching) {
      return <Spinner />;
    }

    if (contacts.length >= 1 || identities.hasPostalAddress === '1' || (!webViewMode && identities.redirectUrl)) {
      return (
        <div id="choice-form">
          <Row>
            <Col xs={12} sm={12} md={6} lg={6} xl={6}>
              {contacts.length >= 1 && <ContactList contacts={contacts} onContactClick={this.handleClick} />}
              <Space size="l" />
            </Col>
          </Row>
          { // ALTERNATIVE MESSAGE FOR SECONDARY ACCOUNT
            (!webViewMode && accountLevel === MULTIBAL_ACCOUNT) && <Row>
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                <Text as="h2" bold size="l" id="temporary-password-subtitle">
                  {getTitle(contacts)}
                </Text>
                <Space size="l" />
                <Flex flexDirection="column">
                  <MultibalCannotUseContact redirectUrl={identities.redirectUrl} />
                </Flex>
              </Col>
            </Row>
          }
          { // ALTERNATIVE MESSAGE FOR OTHER ACCOUNT TYPE
            (accountLevel !== MULTIBAL_ACCOUNT && (identities.hasPostalAddress === '1' || (!webViewMode && identities.redirectUrl))) && <Row>
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                <Text as="h2" bold size="l" id="temporary-password-subtitle">
                  {getTitle(contacts)}
                </Text>
                <Space size="l" />
                <Flex flexDirection="column">
                  {identities.hasPostalAddress === '1' && <GetLetter order={letterOrder} />}
                  {(!webViewMode && identities.redirectUrl) && <UseTemporaryPassword redirectUrl={identities.redirectUrl} />}
                </Flex>
              </Col>
            </Row>
          }
        </div>
      )
    } else {
      return <NoContact />;
    }
  }
}

ChoiceView.defaultProps = {
  identities: {
    hasPostalAddress: '0',
    isFirstConnection: '0',
    redirectUrl: null,
  },
  contacts: [],
  isFetching: true,
};

ChoiceView.propTypes = {
  /** Action to get all no sensitive data of the user */
  getIdentitiesAndContacts: PropTypes.func.isRequired,
  /** Action to create an otp with the selected contact way by calling partners api */
  sendOtp: PropTypes.func.isRequired,
  /** Action to set the contact way user preference */
  setSelectedContact: PropTypes.func.isRequired,
  /** Array contact list */
  contacts: PropTypes.arrayOf(PropTypes.shape({
    contactId: PropTypes.string,
    contactView: PropTypes.string,
    contactType: PropTypes.string,
    contactValidity: PropTypes.string,
  })),
  /** Boolean fetching data */
  isFetching: PropTypes.bool,
  /** Object user properties */
  identities: PropTypes.shape({
    /** String user postal address */
    hasPostalAddress: PropTypes.oneOf(['1', '0']),
    /** Boolean first connection user */
    isFirstConnection: PropTypes.oneOf(['1', '0']),
    /** String redirect url to IDME for temporary password */
    redirectUrl: PropTypes.string,
  }).isRequired,
  /** Boolean webview mode */
  webViewMode: PropTypes.bool,
};

export default ChoiceView;
